import { Button } from "@blueprintjs/core"
import { ChangeEvent, useState } from "react"
import { IToposStore, useToposStore } from "../../data/store"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts"

const SearchLandscape = (props: any) : JSX.Element => {
    const {width} = useScreenSize()
    const isLandscapeClapanOpen : boolean = useToposStore((state: IToposStore) => state.isLandscapeClapanOpen )
    const [search, setSearch] = useState<string>(props.search)
    const onChange = (evt: ChangeEvent<HTMLInputElement>) => {
        setSearch(evt.target.value)
    }
    const onOpen = () => {
        useToposStore.setState({isLandscapeClapanOpen: !isLandscapeClapanOpen})
    }
    return (
        <div className="topos-landscape-search ">
            <input
                type="text"
                value={search}
                onChange={onChange}
                className="form-control input dark"
            />
            <Button minimal icon="search" onClick={ () => props.onChange(search) } />
            {
                width < WINDOW_WIDTH.TABLET &&
                <Button className=" " icon="arrow-left" minimal onClick={onOpen}/>
            }
        </div>
    )
} 

export default SearchLandscape